import * as engagementsTypes from './engagementsTypes';
import { FORM_MODE } from '../../../../constants/constants';
import {
  GET_ENGAGEMENTS_USERS,
  GET_ENGAGEMENTS_USERS_SUCCESS,
  GET_ENGAGEMENT_TEAMS_LIST_SUCCESS,
  GET_ENGAGEMENT_USERS_LIST_SUCCESS,
  GET_USER_COUNTRY_LIST_SUCCESS,
  SAVE_ENGAGEMENT_TEAM_DETAILS_SUCCESS,
  GET_ENGAGEMENT_TEAM_DETAILS_SUCCESS,
  SET_ENGAGEMENT_TEAM_DETAILS,
} from './engagementsTypes';
import cloneDeep from 'lodash.clonedeep';

const initialState = {
  engagementDetailRecordMode: FORM_MODE.CLOSE,
  engagementApplicationEnvironmentKey: null,
  engagementDataAccessGroupsDetails: {},
  teamName: '',
  teamDetails: {
    mode: FORM_MODE.CLOSE,
  },
  countryList: [],
  engagementUserDetails: {
    mode: 'Close',
    profileKey: '',
    firstName: '',
    lastName: '',
    email: '',
    roles: [],
    engagements: [],
    updatedAt: new Date().getTime(),
    availabilityDetails: {},
  },
  systemRoles: [],
  engagementsList: [
    {
      applicationEngagementKey: 101,
      applicationEngagementName: 'ABC Company',
    },
    {
      applicationEngagementKey: 102,
      applicationEngagementName: 'GMT Worldwide',
    },
  ],
  frequencyList: [],
  slaTriggerQuestionnaireList: [],
  experianValidatedList: [],
  accessAllowedOptions:[],
  enableDelegateChatOptions:[],
  onHoldResponseByOptions:[],
  paymentByOptions:[],
  paymentFrequencyOptions:[],
  questionnaireAccessOptions:[],
  returnApprovalByOptions:[],
};

const engagementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case engagementsTypes.ENGAGEMENT_TEAM_DETAILS_FORM_ATTR: {
      if (action.data == 'Close') {
        return { ...state, teamDetails: { [action.field]: action.data } };
      }
      return { ...state, teamDetails: { ...state.teamDetails, [action.field]: action.data } };
    }
    case engagementsTypes.INIT_ENGAGEMENTS_LIST: {
      return { ...state, engagements: [] };
    }
    case engagementsTypes.SET_ENGAGEMENT_DETAIL_RECORD_MODE: {
      return { ...state, engagementDetailRecordMode: action.mode.mode, engagementApplicationEnvironmentKey: action.mode.engagementId };
    }
    case engagementsTypes.GET_ENGAGEMENTS_SUCCESS: {
      return { ...state, engagements: action.engagements };
    }
    case engagementsTypes.RESET_ENGAGEMENTS_DETAILS: {
      // engagementId: 0, engagementName: '', gfisid: ''
      return { ...state, engagementsDetails: {} };
    }
    case engagementsTypes.GET_ENGAGEMENTS_DETAILS_SUCCESS: {
      return { ...state, engagementsDetails: action.engagementsDetails.data };
    }
    case engagementsTypes.SAVE_ENGAGEMENTS_DETAILS_SUCCESS: {
      return {
        ...state,

        engagementsDetails: action.engagementDetails,
      };
    }
    case GET_ENGAGEMENTS_USERS: {
      return { ...state, engagementUsers: [] };
    }
    case GET_ENGAGEMENTS_USERS_SUCCESS: {
      return { ...state, engagementUsers: action.engagementUsers };
    }
    case GET_ENGAGEMENT_TEAMS_LIST_SUCCESS: {
      return { ...state, engagementTeams: action.engagementTeams };
    }
    case GET_ENGAGEMENT_USERS_LIST_SUCCESS: {
      return { ...state, usersByEngagement: action.usersByEngagement };
    }
    case GET_USER_COUNTRY_LIST_SUCCESS: {
      return { ...state, countryList: action.countryList };
    }

    case SAVE_ENGAGEMENT_TEAM_DETAILS_SUCCESS: {
      return {
        ...state,
        saveResponse: action.saveEngagementUserSuccess,
        resetTeamsList: true,
      };
    }
    case GET_ENGAGEMENT_TEAM_DETAILS_SUCCESS: {
      return { ...state, teamDetails: action.teamDetails };
    }
    case SET_ENGAGEMENT_TEAM_DETAILS: {
      return { ...state, teamDetails: action.data };
    }
    case engagementsTypes.SET_ENGAGEMENT_USERDETAIL_OBJECT: {
      return { ...state, engagementUserDetails: cloneDeep(action.data), originalEngagementList: action.data.engagements };
    }
    case engagementsTypes.GET_COUNTRYLIST_SUCCESS:
      return { ...state, countryList: action.data };

    case engagementsTypes.SET_SYSTEM_ROLES:
      return { ...state, systemRoles: action.data };

    case engagementsTypes.GET_USERS_ENGAGEMENT_OPTIONS_SUCCESS: {
      return { ...state, engagementOptions: action.engagementOptions };
    }

    case engagementsTypes.SAVE_ENGAGEMENT_USERS_SUCCESS: {
      return { ...state, engagementUserSave: action.saveEngagementUserSuccess };
    }

    case engagementsTypes.RESET_ENGAGEMENT_USERDETAIL_OBJECT: {
      return {
        ...state,
        engagementUserDetails: {
          profileKey: '',
          firstName: '',
          lastName: '',
          email: '',
          roles: [],
          engagements: [],
          updatedAt: new Date().getTime(),
          availabilityDetails: {},
        },
      };
    }

    case engagementsTypes.SET_USERS_DETAIL_ENGAGEMENTS: {
      return { ...state, engagementUserDetails: { ...state.engagementUserDetails, engagements: action.engagements } };
    }

    case engagementsTypes.USERDETAIL_FORM_ATTR: {
      return { ...state, engagementUserDetails: { ...state.engagementUserDetails, [action.field]: action.data } };
    }

    case engagementsTypes.SET_ENGAGEMENT_USERSLIST_PAYLOAD: {
      return { ...state, optEngUsersPayload: action.data };
    }

    case engagementsTypes.SET_ENGAGEMENT_TEAMSLIST_PAYLOAD: {
      return { ...state, optEngTeamsPayload: action.data };
    }

    case engagementsTypes.SET_ENGAGEMENT_SEARCHED_TEAM_LIST: {
      return { ...state, searchedTeamUserList: action.data, resetTeamsList: false };
    }

    case engagementsTypes.GET_EXPERIAN_VALIDATED_LIST_SUCCESS: {
      return { ...state, experianValidatedList: action.data.messages };
    }
    case engagementsTypes.SET_ENGAGEMENT_SEARCHED_TEAM_COUNTRY_LIST: {
      return { ...state, searchedTeamCountryList: action.data, resetTeamCountryList: false };
    }

    case engagementsTypes.GET_ENGAGEMENT_DATA_ACCESS_GROUPS: {
      return { ...state, engagementDataAccessGroupsDetails: action.data };
    }

    case engagementsTypes.GET_FREQUENCY_LIST: {
      return { ...state, frequencyList: action.data };
    }

    case engagementsTypes.GET_SLA_TRIGGER_LIST: {
      return { ...state, slaTriggerQuestionnaireList: action.data };
    }
    case engagementsTypes.GET_MASTER_VALUES_FOR_ENGAGEMENT_LIST: {
      return { 
        ...state,
        accessAllowedOptions: action.accessAllowedOptions,
        enableDelegateChatOptions:action.enableDelegateChatOptions,
        onHoldResponseByOptions:action.onHoldResponseByOptions,
        paymentByOptions:action.paymentByOptions,
        paymentFrequencyOptions:action.paymentFrequencyOptions,
        questionnaireAccessOptions:action.questionnaireAccessOptions,
        returnApprovalByOptions:action.returnApprovalByOptions,
        siApplicableOptions:action.siApplicableOptions,
        serviceSectionOptions:action.serviceSectionOptions,
      };
    }

    default:
      return state;
  }
};

export { initialState };
export default engagementsReducer;
